import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { AdditionalflatComponent } from './additionalflat.component';
import { AdditionalflatDetailComponent } from './additionalflat-detail.component';
import { AdditionalflatPopupComponent } from './additionalflat-dialog.component';
import { AdditionalflatDeletePopupComponent } from './additionalflat-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class AdditionalflatResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const additionalflatRoute: Routes = [
  {
    path: 'additionalflat',
    component: AdditionalflatComponent,
    resolve: {
      'pagingParams': AdditionalflatResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.additionalflat.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'additionalflat/:id',
    component: AdditionalflatDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.additionalflat.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const additionalflatPopupRoute: Routes = [
  {
    path: 'additionalflat-new',
    component: AdditionalflatPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.additionalflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'additionalflat/:id/edit',
    component: AdditionalflatPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.additionalflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'additionalflat/:id/delete',
    component: AdditionalflatDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.additionalflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat.route.ts